import { useMemo } from 'react'
import { useIntl } from 'react-intl'
import config from 'constants/config'
import { useAppSelector } from 'hooks/reduxHooks'
import productLabels from 'i18n/productLabels'

function useTourV2VerticalName(): string {
  const intl = useIntl()
  const currentRegionCode = useAppSelector(state => state.geo.currentRegionCode)

  return useMemo(() => {
    if (config.CRUISES_REGIONS?.split(',').includes(currentRegionCode)) {
      return intl.formatMessage(productLabels.tours)
    }

    return intl.formatMessage(productLabels.toursAndCruises)
  }, [intl, currentRegionCode])
}

export default useTourV2VerticalName
